if (process.env.NODE_ENV === 'production') {
  module.exports = require('./vue.common.prod.js')
} else {
  module.exports = require('./vue.common.dev.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue@2.6.14/~/vue/dist/vue.common.js
// module id = k28z
// module chunks = 5